export const achievementsCounter = (): void => {
  const achivementsComponents = document.querySelectorAll('.js-achievements') as unknown as HTMLElement[]

  const bodyElement = document.querySelector('body') as unknown as HTMLElement

  if (!achivementsComponents || !bodyElement) {
    return
  }

  achivementsComponents.forEach(achivement => {
    const allLocalElems = achivement.querySelectorAll('.js-achivements-single') as unknown as HTMLElement[]

    allLocalElems.forEach(elem => {
      const animateValue = (element: HTMLElement) => {
        const numberElement = element.querySelector('.js-achievements-titleNumber') as unknown as HTMLElement

        if (!numberElement) {
          return
        }

        const numberString = numberElement.textContent?.replace(/\D/g, '') as string

        const affixString = numberElement.textContent?.replace(/[0-9]/g, '') as string

        const numberInt = parseInt(numberString)

        let current = 0
        const stepTimer = 4500 / 100
        let increment = numberInt / stepTimer
        if (increment > numberInt) increment = 1

        const timer = setInterval(function () {
          current += increment
          numberElement.innerHTML = `${Math.floor(current)}${affixString}`.replace(/\s/g, '')
          if (current >= numberInt || numberInt === 1) {
            numberElement.innerHTML = `${numberInt}${affixString}`.replace(/\s/g, '')
            clearInterval(timer)
          }
        }, stepTimer)
      }

      const isInViewport = (elem: HTMLElement) => {
        const rect = elem.getBoundingClientRect()

        return (
          rect.top >= 0 &&
          (rect.left + parseInt(window.getComputedStyle(elem).paddingLeft) + parseInt(window.getComputedStyle(elem).width) / 4) >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          (rect.right - parseInt(window.getComputedStyle(elem).paddingRight) - parseInt(window.getComputedStyle(elem).width) / 4) <= (window.innerWidth || document.documentElement.clientWidth)
        )
      }

      const checkElementForAnimation = (elem) => {
        if (isInViewport(elem) && !elem.classList.contains('-hadCounter')) {
          elem.classList.add('-hadCounter')

          clearInterval(checkerInterval)
          animateValue(elem)
        }
      }

      // On resize
      window.addEventListener('resize', () => {
        checkElementForAnimation(elem)
      })

      // On scroll
      window.addEventListener('scroll', () => {
        checkElementForAnimation(elem)
      })

      const checkerInterval = setInterval(() => {
        checkElementForAnimation(elem)
      }, 250)
    })
  })
}
